import type {
  CountrySimple,
  WorkspaceSettingsQuery,
} from "@src/__generated__/urql-graphql";
import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import type { CompaniesSettingsState } from "@src/stores/forms/SettingsModalState/CompaniesSettingsState";
import mapToOptions from "@src/utils/map-to-options";
import { computed, makeObservable, observable } from "mobx";

type Country = {
  value: CountrySimple["id"];
  label: CountrySimple["name"];
};
export class CompaniesSettingsStore implements BaseStore {
  @observable.ref countries: Country[] = [];

  constructor(
    public appStore: AppStore,
    public form: CompaniesSettingsState,
  ) {
    makeObservable(this);
  }

  init(data: WorkspaceSettingsQuery) {
    this.countries = data.countrySimpleMap.map(({ id, name }) => ({
      value: id,
      label: name,
    }));
  }

  @computed
  get currencyOptions() {
    return mapToOptions.currencies(this.appStore.workspaceStore.currencies);
  }
}
